import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { DashNotificationsService } from 'app/services/dash-notifications.service';
import { InvitationsService } from 'app/services/invitation.service';

@Component({
  selector: 'unconfirmed-login-prompt',
  templateUrl: './unconfirmed-login-prompt.component.html',
  styleUrls: ['./unconfirmed-login-prompt.component.scss']
})
export class UnconfirmedLoginPromptComponent implements OnInit {

  emailAddress: string;

  constructor(
    private invitationService: InvitationsService,
    private notifications: DashNotificationsService,
    private location: Location,
  ) { }

  ngOnInit(): void {
    const { emailAddress } = this.location.getState() as { emailAddress: string };
    this.emailAddress = emailAddress;
  }


  renewInvitation(){
    this.invitationService.renew(this.emailAddress).subscribe(() => {
      this.notifications.success('Check your email, we\'ve sent you another invitation!')
    });
  }
}
